import React from 'react';
import {Button, Modal} from 'react-bootstrap';

const ConfirmDialog = (props)  => (
  <Modal show={props.show} onHide={props.onClose} bsSize="small">
    <Modal.Header>
      <Modal.Title>{props.title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{props.question}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button onClick={props.onConfirm}>Yes</Button>
      <Button onClick={props.onClose}>No</Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/confirmDialog.js